import React from "react";
import { Button, Text, NavLink as ThemeNavLink } from "theme-ui";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { icons } from 'lucide-react';
import { typography, colors } from "../../styles/theme";

const activeStyle = {}; // This object can be used in future for defining custom styles that will be applied to a link when it is in an "active" state.

const styledLink = {
  ...typography.textMd500,
  cursor: "pointer",
  color: colors.black,
  textDecoration: "none",
  transition: "color 0.3s",
  display: "flex",
  alignItems: "center",
  "&:hover": {
    color: colors.primaryMain,
    "& svg": {
      color: colors.primaryMain,
    },
  },
};

const NavLink = ({ to, children, onClick, iconName, iconPosition, customStyles }) => {
  const linkProps = {
    onClick: (event) => {
      if (to === "#") {
        event.preventDefault();
        if (typeof onClick === "function") {
          onClick();
        }
      }
    },
  };

  const LucideIcon = icons[iconName];

  const iconStyle = {
    marginRight: iconPosition === "left" ? "0.5rem" : "0",
    marginLeft: iconPosition === "right" ? "0.5rem" : "0",
  };

  const linkContent = (
		<>
			{iconPosition === "left" && iconName && (
				<LucideIcon
					style={iconStyle}
					size={20}
				/>
			)}
			<Text>{children}</Text>
			{iconPosition === "right" && iconName && (
				<LucideIcon
					style={iconStyle}
					size={20}
				/>
			)}
		</>
	);

  if (onClick) {
		return (
			<Button
				sx={{ bg: "transparent", ...styledLink, ...customStyles }}
				onClick={onClick}
			>
				{linkContent}
			</Button>
		);
	}

  return (
    <ThemeNavLink
      as={Link}
      to={to}
      sx={{ ...styledLink, ...customStyles }}
      activeStyle={activeStyle}
      {...linkProps}
    >
      {linkContent}
    </ThemeNavLink>
  );
};

NavLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  iconName: PropTypes.string,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  customStyles: PropTypes.object,
};

NavLink.defaultProps = {
  to: "#",
  customStyles: {},
};

export default NavLink;
